import { createFileRoute } from '@tanstack/react-router';

import { AdminUserDetailPage } from '@/features/admin/components/admin-user-detail-page';

export const Route = createFileRoute('/admin/users/$userId')({
  component: AdminUserDetailRoute,
});

function AdminUserDetailRoute() {
  const { userId } = Route.useParams();

  return <AdminUserDetailPage userId={userId} />;
}
